import {Component, EventEmitter, HostListener, Input, Output, ViewChild} from '@angular/core';
import {fadeInOut} from '../../animations/animations';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  animations: [fadeInOut],
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  @Input() set show(isShown: boolean) {
    this.isShown = isShown;

    if (isShown) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
  }

  @Input() header: string;
  @Input() subHeader: string;
  @Input() cancelBtnText = 'Cancel';
  @Input() saveBtnText = 'Save';
  @Input() disableSaveBtn: boolean;
  @Input() hideSaveButton: boolean;
  @Input() showHeader = true;
  @Input() hasControls;
  @Input() minWidthDefault = true;
  @Input() blur: boolean;
  @Input() hideHeaderUnderline: boolean;
  @Input() minWidth: number;
  @Input() minHeight: number;
  @Input() maxWidth: number;
  @Input() headerIcon: 'warning' | 'info' | 'none' = 'none';
  @Input() headerIconName: string = 'icon-exclamation-triangle';
  @Input() headerCustomClasses: string;
  @Input() saveBtnMinWidth = 110;
  @Input() hideControlsDivider;
  @Input() subheaderIconName;
  @Input() headerIconClasses;
  @Input() hasCloseButton: boolean;
  @Input() maxHeight: string = '90vh';

  
  @Input() scrollable: boolean;
  @Input() scrollableMaxHeight = 'calc(100vh - 241px)';
  
  @Output() save: EventEmitter<void> = new EventEmitter();
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  
  @Output() onCancelKeyDown: EventEmitter<void> = new EventEmitter();
  @Output() onSubmitKeyDown: EventEmitter<void> = new EventEmitter();
  @Output() closeClicked: EventEmitter<void> = new EventEmitter();

  isShown: boolean;

  @ViewChild('cancelButton') cancelButton;
  @ViewChild('submitButton') submitButton;

  @HostListener('document:keydown', ['$event'])
  keyDownEscape(ev: KeyboardEvent): void {
    if (ev.code === 'Escape' && this.isShown) {
      this.cancel.emit();
    }
  }

  focusCancelButton(): void {
    this.cancelButton.focus();
  }

  focusSubmitButton(): void {
    this.submitButton.focus();
  }

  cancelKeydownTab(): void {
    event.preventDefault();
    this.onCancelKeyDown.next();
  }

  submitKeydownTab(): void {
    event.preventDefault(); 
    this.onSubmitKeyDown.next()
  }

  closeButtonClicked(): void {
    this.closeClicked.emit();
  }

}
